package ui.styles

import web.cssom.rgb

object Colors{
    val primaryMain = rgb(57,49,133)

    val secondaryMain = rgb(47,47,53)
    val tertiaryMain = rgb(37,36,39)


    val brCard = rgb(57,215,200)
}